import AhmadAhmadLocales from "@/data/localization/AboutAhmad.locales";
import {
  FlexContainer,
  Heading1,
  Heading2,
  Heading3,
  LI,
  Section,
  SectionArticle,
  Span,
  UL,
  useLocales,
} from "@crescentapplications/react-ui";

export default function WorkExperience() {
  const l = useLocales();

  return (
    <Section bgColor="frame" id="work" padding="lg">
      <FlexContainer direction="column" gap="xl" fullWidth>
        <Heading1>{l(AhmadAhmadLocales.workExperience)}</Heading1>

        <SectionArticle bgColor="overlay" gap="sm">
          <Heading2>{l(AhmadAhmadLocales.currently)}</Heading2>
          <UL>
            <LI>
              {l(AhmadAhmadLocales.sD1A)}{" "}
              <a
                href="https://www.crescentapplications.com"
                target="_blank"
                rel="noreferrer"
              >
                {l(AhmadAhmadLocales.sD1B)}
              </a>{" "}
              {l(AhmadAhmadLocales.sD1C)}
              {l(AhmadAhmadLocales.period)}
            </LI>

            <LI>
              {l(AhmadAhmadLocales.foundingPresident)}{" "}
              <a
                href="https://web.facebook.com/CrescentAcademy"
                target="_blank"
                rel="noreferrer"
              >
                {l(AhmadAhmadLocales.ed1B)}
              </a>{" "}
              {l(AhmadAhmadLocales.ed1C)}
              {l(AhmadAhmadLocales.period)}
            </LI>

            <LI>
              {l(AhmadAhmadLocales.foundingPresident)}{" "}
              {/* <a
                  href="https://www.crescentapplications.com"
                  target="_blank"
                  rel="noreferrer"
                > */}
              {l(AhmadAhmadLocales.nvc)}
              {/* </a> */}
              {l(AhmadAhmadLocales.period)}
            </LI>
          </UL>
        </SectionArticle>

        <SectionArticle bgColor="overlay" gap="sm">
          <Heading2>{l(AhmadAhmadLocales.previously)}</Heading2>
          <Heading3 color="tertiary">
            {l(AhmadAhmadLocales.softwareDevelopment)}
          </Heading3>
          <UL>
            <LI>
              {l(AhmadAhmadLocales.sD2A)}{" "}
              <Span className="english-font" fontWeight={600}>
                xQuran
              </Span>{" "}
              {l(AhmadAhmadLocales.sD2B)}
              {l(AhmadAhmadLocales.period)}
            </LI>

            <LI>
              {l(AhmadAhmadLocales.sD3A)}
              {l(AhmadAhmadLocales.period)}
            </LI>
          </UL>

          <Heading3 color="tertiary">{l(AhmadAhmadLocales.education)}</Heading3>
          <UL>
            <LI>
              {l(AhmadAhmadLocales.ed2A)}{" "}
              <a
                href="https://www.facebook.com/newvisioninternationalschools/"
                target="_blank"
                rel="noreferrer"
              >
                {l(AhmadAhmadLocales.ed2B)}
              </a>{" "}
              {l(AhmadAhmadLocales.ed2C)}
              {l(AhmadAhmadLocales.period)}
            </LI>

            <LI>
              {l(AhmadAhmadLocales.ed3A)}{" "}
              <a href="http://www.ngegypt.net" target="_blank" rel="noreferrer">
                {l(AhmadAhmadLocales.ed3B)}
              </a>{" "}
              {l(AhmadAhmadLocales.ed3C)}
              {l(AhmadAhmadLocales.period)}
            </LI>
          </UL>

          <Heading3 color="tertiary">
            {l(AhmadAhmadLocales.construction)}
          </Heading3>
          <UL>
            <LI>
              {l(AhmadAhmadLocales.cn1A)}{" "}
              <Span fontWeight={600}>{l(AhmadAhmadLocales.cn1B)}</Span>{" "}
              {l(AhmadAhmadLocales.cn1C)}
              {l(AhmadAhmadLocales.period)}
            </LI>

            <LI>
              {l(AhmadAhmadLocales.cn3A)}{" "}
              <Span fontWeight={600}>{l(AhmadAhmadLocales.cn3B)}</Span>{" "}
              {l(AhmadAhmadLocales.cn3C)}
              {l(AhmadAhmadLocales.period)}
            </LI>

            <LI>
              {l(AhmadAhmadLocales.cn2A)}{" "}
              <Span fontWeight={600}>{l(AhmadAhmadLocales.cn2B)}</Span>{" "}
              {l(AhmadAhmadLocales.cn2C)}
              {l(AhmadAhmadLocales.period)}
            </LI>
          </UL>

          <Heading3 color="tertiary">{l(AhmadAhmadLocales.other)}</Heading3>
          <UL>
            <LI>
              {l(AhmadAhmadLocales.ot1A)}{" "}
              <Span fontWeight={600}>{l(AhmadAhmadLocales.ot1B)}</Span>{" "}
              {l(AhmadAhmadLocales.ot1C)}{" "}
              <Span fontWeight={600}>{l(AhmadAhmadLocales.ot1D)}</Span>{" "}
              {l(AhmadAhmadLocales.ot1E)}
              {l(AhmadAhmadLocales.period)}
            </LI>

            <LI>
              {l(AhmadAhmadLocales.ot2A)}{" "}
              <Span className="english-font" fontWeight={600}>
                {l(AhmadAhmadLocales.ot2B)}
              </Span>
              {l(AhmadAhmadLocales.ot2C)}
              {l(AhmadAhmadLocales.period)}
            </LI>
          </UL>
        </SectionArticle>
      </FlexContainer>
    </Section>
  );
}
